module.exports = __webpack_public_path__ + "img/return-badge.a903bd78.svg";